import { render, staticRenderFns } from "./SlglrsMUTG_AllIssuesPage.vue?vue&type=template&id=3e4d301c&scoped=true&"
import script from "./SlglrsMUTG_AllIssuesPage.vue?vue&type=script&lang=js&"
export * from "./SlglrsMUTG_AllIssuesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d301c",
  null
  
)

export default component.exports